import styled from 'styled-components';

export const RoSliderWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 68px;
  z-index: 7;
`;

export const RadarSlider = styled.div`
  .noUi-target {
    border: none;
    background: none;
    position: relative;
    box-shadow: none;
    &:after {
      content: '';
      width: 120%;
      left: -10%;
      background: rgba(255, 255, 255, 0.8);
      border: 1px solid #ffffff;
      top: 0;
      height: 100%;
      display: block;
      position: absolute;
      box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.12);
    }
  }
  .noUi-horizontal {
    height: 30px;
    border: none;
    .noUi-handle {
      top: 1px;
    }
  }
  .noUi-tooltip {
    background: transparent;
    border: none;
    outline: none;
  }
  .noUi-handle {
    outline: none;
    border: none;
    &:after {
      display: none;
    }
    &:before {
      display: none;
    }
  }
`;
